import { PureComponent } from 'react';

const clickOutside = (WrappedComponent, className) => {
    return class extends PureComponent {
        componentDidMount() {
            document.addEventListener('mousedown', this.handleClickOutside);
        }

        componentWillUnmount() {
            document.removeEventListener('mousedown', this.handleClickOutside);
        }

        handleClickOutside = (event) => {
            if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.wrappedComponentRef.onClickOutside) {
                this.wrappedComponentRef.onClickOutside();
            }
        }

        render() {
            return (
                <div className={className} ref={ref => { this.wrapperRef = ref; }}>
                    <WrappedComponent ref={ref => { this.wrappedComponentRef = ref; }} {...this.props} />
                </div>); 
        }
    };
}

export default clickOutside;
